import * as React from 'react';
import ReactMinimalPieChart from 'react-minimal-pie-chart';

import { Bem } from '../../service/Bem/Bem';
import {
    DisplayPoint,
    OutdoorScreen,
    PointColor
} from '../../typings/displayMap';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './PlaceMarkOutdoor.css';

export interface PlaceMarkOutdoorProps {
    pointData: DisplayPoint;
    selectedScreensPoint: string[];
}

export class PlaceMarkOutdoor extends React.Component<PlaceMarkOutdoorProps> {
    render() {
        const { pointData: point, selectedScreensPoint: selected } = this.props;
        const screens: OutdoorScreen[] = point.screens as OutdoorScreen[];
        const icon = {
            1: Shape2Icon.outdoorBillBoard,
            2: Shape2Icon.outdoorSuperSite,
            3: Shape2Icon.outdoorMediaF,
            5: Shape2Icon.outdoorCitiFormat
        };
        const allSelected = screens.every(screen =>
            selected.includes(screen.id)
        );
        let screenIcon = Shape2Icon.outdoorBillBoard;

        if (screens[0].facilityTypeId && icon[screens[0].facilityTypeId]) {
            screenIcon = icon[screens[0].facilityTypeId];
        }

        return (
            <div
                className={Bem.cls('placemark-outdoor', '', {
                    multi: screens.length > 1 ? 'yes' : ''
                })}
                data-platform-count={screens.length}
            >
                <ReactMinimalPieChart
                    className={Bem.cls('placemark-outdoor', 'pie-chart')}
                    data={screens.map((screen: OutdoorScreen) => {
                        const deletedScreenWeight =
                            screen.deletedScreenWeight || 0;

                        let color = selected.includes(screen.id)
                            ? PointColor.green
                            : PointColor.blue;

                        if (deletedScreenWeight) {
                            color = PointColor.grey;
                        }

                        return {
                            value: screen.screenWeight,
                            color: color
                        };
                    })}
                    startAngle={screens[0].transform + 180}
                />
                {screens.map((screen: OutdoorScreen) => {
                    const deletedScreenWeight = screen.deletedScreenWeight || 0;
                    let directionBackground = PointColor.blue;

                    if (deletedScreenWeight) {
                        directionBackground = PointColor.grey;
                    } else if (allSelected || selected.includes(screen.id)) {
                        directionBackground = PointColor.green;
                    }

                    if (typeof screen.transform !== 'number') {
                        return <></>;
                    }

                    return (
                        <div
                            key={screen.id}
                            className={Bem.cls(
                                'placemark-outdoor',
                                'direction'
                            )}
                            style={{
                                // TODO зафиксировать числа
                                transform:
                                    'rotate(' +
                                    (-135 + screen.transform) +
                                    'deg)',
                                background: directionBackground
                            }}
                        />
                    );
                })}
                <Shape2
                    cls={Bem.cls('placemark-outdoor', 'icon')}
                    width={16}
                    height={16}
                    icon={screenIcon}
                    theme={Shape2Theme.default}
                />
            </div>
        );
    }
}
